import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import Forms from "./pages/forms/Forms";
import Responses from "./pages/forms/Responses";
import ResponseDetails from "./pages/forms/ResponseDetails";
import PrivateRoute from "./components/Routes/PrivateRoute";
import { AuthProtect } from "./components/Routes/AuthProtect";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {" "}
        <Route element={<AuthProtect />}>
          <Route path="/login" Component={Login} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route path="/" Component={Forms} />
          {/* <Route path="/forms" Component={Forms} /> */}
          <Route path="/forms/t0DoMPhK" Component={Responses} />
        </Route>
        <Route path="/forms/t0DoMPhK/:id" Component={ResponseDetails} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
